var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticClass: "ik-list-table",
      attrs: {
        data: _vm.pageData.outOrd.body["outOrdItem"],
        height: "250",
        "header-row-class-name": "ik-list-table-header-row",
        "header-cell-class-name": "ik-list-table-header-cell",
        "row-class-name": "ik-list-table-body-row",
        "cell-class-name": "ik-list-table-body-cell",
        "highlight-current-row": true,
        stripe: true,
        border: true,
      },
    },
    [
      _c("el-table-column", {
        attrs: { prop: "materielCode", label: "药品编码", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "materielName", label: "药品名称", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "supplierName", label: "供应商", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "manufacturerName", label: "生产商", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "batchCode", label: "批次", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "number", label: "数量", align: "center" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }